import lifeInsurance from './lifeInsurance';
import autoInsurance from './autoInsurance';
import homeInsurance from './homeInsurance';
import floodInsurance from './floodInsurance';
import businessInsurance from './businessInsurance';
import petInsurance from './petInsurance';
import umbrellaInsurance from './umbrellaInsurance';
import medicare from './medicare';

// Import other product data as they're created

const productData = {
  lifeinsurance: lifeInsurance,
  autoinsurance: autoInsurance,
  homeinsurance: homeInsurance,
  floodinsurance: floodInsurance,
  businessinsurance: businessInsurance,
  petinsurance: petInsurance,
  umbrellainsurance: umbrellaInsurance,
  medicare: medicare,
  
  // Add other product data as they're created
};

export default productData; 